import type { CallDto, SendBookingLinkParamsDto } from '@carvia/ros-client-types';
import { httpClient } from './http-client';

class PhoneService {
  async dial(phoneNumber: string): Promise<void> {
    await httpClient.post('/phone/dial', { phoneNumber });
  }

  async getRecentCalls() {
    const res = await httpClient.get('/phone/recent');
    return res.data as CallDto[];
  }

  async sendBookingLink(params: { phoneNumber: string; params: SendBookingLinkParamsDto }) {
    const res = await httpClient.post('/phone/send-booking-link', params);
    return res.data as { status: 'OK' };
  }
}

export const phoneService = new PhoneService();
